import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/room-stanza-della-trave/components/StanzaDellaTraveInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
